export const constants = {
    isTouch: "ontouchstart" in window ? function () {
        document.body.classList.add("touch");
        return true;
    }() : function () {
        document.body.classList.add("no-touch");
        return false;
    }(),
    body: $("body")
};

$('.colored-section').each(function () {
    const sectionBg = $(this).find('.section-bg');
    if (sectionBg.length) {
        $(this).addClass("section-has-parallax");
    }
})


// WEBPACK FOOTER //
// ./assets/js/modules/module.js